module.exports = __webpack_public_path__ + "img/ru.a0a0eea4.svg";